import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { NoPreloading } from '@angular/router';

const routes: Routes = [
  // {
  //   path: '',
  //   // redirectTo: 'folder/Inbox',
  //   redirectTo: 'login',
  //   pathMatch: 'full'
  // },
  //nuevas rutas para el login
  { path: '', redirectTo: 'auth', pathMatch: 'full' }, // al abrir la app
  // 🔹 Módulo admin (todas las páginas cargadas desde AdminRoutingModule)
  // { path: 'admin', 
  //   loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
  // },
  { path: 'admin', 
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
  },
  { path: 'auth', 
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) 
  },
  { path: 'clientes', 
    loadChildren: () => import('./modules/clientes/clientes.module').then(m => m.ClientesModule)
  },
  { path: 'productos', 
    loadChildren: () => import('./modules/productos/productos.module').then(m => m.ProductosModule)
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule)
  },
  // {
  //   path: 'create-product',
  //   loadChildren: () => import('./pages/create-product/create-product.module').then( m => m.CreateProductPageModule)
  // },
  // {
  //   path: 'list-products',
  //   loadChildren: () => import('./pages/list-products/list-products.module').then( m => m.ListProductsPageModule)
  // },
  // {
  //   path: 'list-p-xavier',
  //   loadChildren: () => import('./pages/list-p-xavier/list-p-xavier.module').then( m => m.ListPXavierPageModule)
  // },
  // {
  //   path: 'create-person',
  //   loadChildren: () => import('./pages/create-person/create-person.module').then( m => m.CreatePersonPageModule)
  // },
  // {
  //   path: 'create-category',
  //   loadChildren: () => import('./pages/create-category/create-category.module').then( m => m.CreateCategoryPageModule)
  // },
  // {
  //   path: 'xcreate-product',
  //   loadChildren: () => import('./pages/xcreate-product/xcreate-product.module').then( m => m.XcreateProductPageModule)
  // },
  // {
  //   path: 'create-client',
  //   loadChildren: () => import('./pages/create-client/create-client.module').then( m => m.CreateClientPageModule)
  // },
  // {
  //   path: 'create-product-price',
  //   loadChildren: () => import('./pages/create-product-price/create-product-price.module').then( m => m.CreateProductPricePageModule)
  // },
  // {
  //   path: 'list-product-price',
  //   loadChildren: () => import('./pages/list-product-price/list-product-price.module').then( m => m.ListProductPricePageModule)
  // },
  // {
  //   path: 'list-client',
  //   loadChildren: () => import('./pages/list-client/list-client.module').then( m => m.ListClientPageModule)
  // },
  {
    path: 'create-commande',
    loadChildren: () => import('./pages/create-commande/create-commande.module').then( m => m.CreateCommandePageModule)
  },
  // {
  //   path: 'login-page',
  //   loadChildren: () => import('./pages/login-page/login-page.module').then( m => m.LoginPagePageModule)
  // },
  // {
  //   path: 'login',
  //   loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  // }
  {
    path: 'inventory',
    loadChildren: () =>
      import('./modules/inventory/inventory.module')
        .then(m => m.InventoryModule)
  },
  {
    path: 'pos',
    loadChildren: () =>
      import('./modules/pos/pos.module')
        .then(m => m.PosModule)
  },
  {
    path: 'finance',
    loadChildren: () =>
      import('./modules/finance/finance.module')
        .then(m => m.FinanceModule)
  },  
  {
    path: 'reporting',
  
    loadChildren: () =>
      import('./modules/reporting/reporting.module')
        .then(m => m.ReportingModule)
  },
  { path: '**', redirectTo: 'auth' },
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
